module.exports = __webpack_public_path__ + "img/travel-diary.be5da012.webp";